/**
 * Tiny pill showing how long the last fetch took.  Matches the Data Center
 * indicator but renders in seconds (Data Center used ms).  When the elapsed
 * time is under one second we show "<1 sec" so the user sees an immediate
 * "snappy" signal rather than a raw 12 ms number.
 *
 * Usage in any page:
 *     const [loadMs, setLoadMs] = useState<number | null>(null);
 *     // …in your fetch:
 *     const t0 = performance.now();
 *     try { … }
 *     finally { setLoadMs(performance.now() - t0); … }
 *     // …in your section header:
 *     <LoadTimeChip ms={loadMs} loading={loading} />
 */
import './LoadTimeChip.css';

interface Props {
  ms:       number | null;
  loading?: boolean;
}

export function fmtLoadSeconds(ms: number | null): string {
  if (ms === null) return '';
  // ALWAYS seconds (user decision 2026-07-02 — no "ms" form): sub-second loads
  // render as "0.3 sec", others as "1.4 sec".
  return `${(ms / 1000).toFixed(1)} sec`;
}

export function LoadTimeChip({ ms, loading }: Props) {
  if (ms === null) return null;
  return (
    <span
      className="load-time-chip"
      title={`${Math.round(ms)} ms`}
    >
      <i className="ti ti-clock" />
      {loading ? 'Loading…' : `Loaded in ${fmtLoadSeconds(ms)}`}
    </span>
  );
}
